import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import Forms from './components/Forms/index';

const CadastrosDisponibilidadeMain = () => {
  const {
    t
  } = useTranslation('common');
  return <Container fluid>
            <Col md={12}>
                <PageHeader title="" routeSegments={[{
        name: 'Início',
        path: '/'
      }, {
        name: 'Disponibilidade',
        path: '/pages/programacao/disponibilidade'
      }, {
        name: 'Criar'
      }]} />
            </Col>
            <Forms />
        </Container>;
};

export default CadastrosDisponibilidadeMain;
